module.exports = __webpack_public_path__ + "static/img/IMG_20160224_125321.3221b1a1.jpg";